import React, { useState } from 'react';
import Modal from 'react-modal';
import Select from 'react-select';
import ConfirmReminderModal from '../confirm-reminder-modal';
import { sendCorporateFormManagementReminder } from '../../../../../services/libraries/corporate-library/form-management';
import { isResponseOk } from '../../../../../utility/isResponseOk';
import { toast } from 'react-toastify';

const NOTIFICATION_TYPES = [
  {
    value: 'EMAIL',
    label: 'Email',
  },
  {
    value: 'SMS',
    label: 'SMS',
  },
  {
    value: 'default',
    label: "By default (user's original preference)",
  },
];

const ReminderModal = ({ onClose, corporateFormId, initiatedFormId }) => {
  const [formData, setFormData] = useState({
    notificationType: { value: 'EMAIL', label: 'Email' },
    text: '',
  });
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      const response = await sendCorporateFormManagementReminder(corporateFormId, initiatedFormId, {
        reminderType: formData.notificationType?.value,
        reminderText: formData.text.trim(),
      });

      if (isResponseOk(response)) {
        setIsConfirmModalOpen(false);
        toast.success('Reminder sent successfully');
        onClose();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Modal
        isOpen
        className="modal-default form-management-reminder-modal"
        overlayClassName={'form-management-reminder-modal-overlay'}
        onRequestClose={onClose}
        ariaHideApp={false}
      >
        <h2 className="modal-header">
          Remind users to fill out the form
          <button className="btn btn-icon" onClick={onClose}>
            <i className="icon-icon-x" />
          </button>
        </h2>
        <div className="modal-body">
          <div className="form-wrapper">
            <div className={`form-item`}>
              <label className="form-label">Notification type</label>
              <Select
                options={NOTIFICATION_TYPES}
                isSearchable={false}
                className="form-control-select"
                classNamePrefix="react-select"
                value={formData.notificationType}
                isDisabled
                onChange={(e) => setFormData({ ...formData, notificationType: e })}
                placeholder="Select Notification Type"
              ></Select>
            </div>
          </div>

          <div className="form-wrapper">
            <div className={`form-item`}>
              <label className="form-label">Text</label>
              <textarea
                value={formData.text}
                onChange={(e) => setFormData({ ...formData, text: e.target.value })}
                className="form-control"
                placeholder="Enter reminder message"
              ></textarea>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn"
            onClick={() => setIsConfirmModalOpen(true)}
            disabled={!formData.notificationType || !formData.text.trim()}
          >
            Save
          </button>
        </div>
      </Modal>
      {isConfirmModalOpen && <ConfirmReminderModal onClose={() => setIsConfirmModalOpen(false)} handleSubmit={handleSubmit} />}
    </>
  );
};

export default ReminderModal;
